import React, { memo, useState } from 'react';
import 'lodash';
import { createTwoFactorAuthenticationRequest } from 'requests/users/two-factor-authentication/twoFactorAuthentication';
import { ButtonStyled, Container, InputStyled, InternalForm, Label } from './style';
import UsersTwoFactorAuthenticationSmsForm from '../two-factor-authentication-sms';
import { showNotification } from 'components/FlashMessages';

const UsersTwoFactorAuthenticationsNew = ({ otpDeliveryMethod }) => {
  const [otpAttempt, setOtpAttempt] = useState('');
  const [errors, setErrors] = useState([]);

  const t = key => I18n.t(`users.two_factor_authentications.new.${key}`);

  const showError = message => {
    showNotification({ level: 'error', message: message });
  };

  const onError = (error, field) => {
    setErrors([error[field]]);
  };

  const onOtpAttemptChange = e => {
    setErrors('');
    setOtpAttempt(e.target.value);
  };

  const onSubmit = e => {
    e.preventDefault();

    createTwoFactorAuthenticationRequest(otpAttempt)
      .then(data => {
        Turbo.visit(data.redirect_path);
      })
      .catch(e => {
        onError(e.errors, 'otp_attempt');
        showError(I18n.t('helpers.failure'));
      });
  };

  const otpLabel = () => {
    switch (otpDeliveryMethod) {
      case 'sms':
        return t('code_from_sms');
      case 'qr_code':
        return t('code_from_authenticator_app');
    }
  };

  const smsForm = () => {
    return otpDeliveryMethod === 'sms' && <UsersTwoFactorAuthenticationSmsForm smsAlreadySent />;
  };

  return (
    <Container>
      {smsForm()}
      <InternalForm onSubmit={onSubmit}>
        <Label htmlFor='two-factor-otp-attempt'>{otpLabel()}</Label>
        <InputStyled
          id='two-factor-otp-attempt'
          type='text'
          onChange={onOtpAttemptChange}
          value={otpAttempt}
          errors={errors}
          pattern='[0-9]*'
          autoFocus
        />
        <ButtonStyled className='primary' type='submit' disabled={!otpAttempt} onClick={onSubmit}>
          {t('verify')}
        </ButtonStyled>
      </InternalForm>
    </Container>
  );
};

export default memo(UsersTwoFactorAuthenticationsNew);
